<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
 
    };
  },
  methods: {},
  mounted() {
    // console.log(this.$route.query.kct)
    // if(this.$route.query.kct){
    //   localStorage.setItem("aicsMng_token", this.$route.query.kct);
    // }
  },
};
</script>
